import React, { useState } from 'react';
import { Container, TextField, Button, Grid, Box, Typography, Checkbox, FormControlLabel } from '@mui/material';
import { CreateAccount as ApiCreateAccount } from '../../../api';
import VerifyCode from './VerifyCode';
import Terms from '../Terms';
import { validate } from 'validate.js';
import constraints from '../validate-email-constraints';

const CreateAccount = ({ setAuthenticated }) => {

  const [name, setName] = useState('');
  const [suffix, setSuffix] = useState('');
  const [email, setEmail] = useState('');
  const [info, setInfo] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordInvalid, setConfirmPasswordInvalid] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [verifyStage, setVerifyStage] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const handleSubmit = async e => {
    const emailAddress = email.toLowerCase().trim()
    e.preventDefault();
    setSubmitError(false);
    const validation = validate({emailAddress}, constraints);

    if (validation)
      setSubmitError(validation.emailAddress)
    else if (!termsAccepted)
      setSubmitError('You must accept the terms and conditions')
    else {
      ApiCreateAccount({name, email: emailAddress, password, suffix, info}).then(() => {
        setVerifyStage(true);
      }).catch(e => {
        const error = (e.response && e.response.data && e.response.data.errors) || e.message
        setSubmitError(error);
      });
    }
  }

  const validateConfirmPassword = e => {
    setConfirmPassword(e.target.value);
    setConfirmPasswordInvalid(password !== e.target.value);
  }

  if (showTerms)
    return (
      <Terms 
        email={email} 
        onAccept={(accepted) => {
          if (accepted !== false) {
            setTermsAccepted(true);
          }
          setShowTerms(false);
        }} 
      />
    );

  if (verifyStage)
    return (
      <VerifyCode setAuthenticated={setAuthenticated} email={email} password={password} />
    );

  return (
    <Container maxWidth="md">
      <Typography component="h1" variant="h4">Create Account</Typography>
      {submitError ? <Typography component="p" color="error">{submitError}</Typography> : null}
      <form onSubmit={handleSubmit}>
        <TextField sx={{marginTop: 1}} value={name} name="name" fullWidth={true} required={true} label="Full name" id="name" onChange={e => setName(e.target.value)} />
        <TextField sx={{marginTop: 1}} value={suffix} name="suffix" fullWidth={true} required={false} label="Professional suffix" id="suffix" onChange={e => setSuffix(e.target.value)} /> 
        <TextField sx={{marginTop: 1}} value={email} name="email" fullWidth={true} required={true} label="Email address" id="email" onChange={e => setEmail(e.target.value)} />
        <TextField sx={{marginTop: 1}} value={info} name="info" fullWidth={true} required={true} label="Telespecialty group" id="info" onChange={e => setInfo(e.target.value)} />
        <TextField sx={{marginTop: 1}} value={password} name="password" type="password" fullWidth={true} required={true} label="Password" id="password" autoComplete="false" onChange={e => setPassword(e.target.value)} />
        <TextField sx={{marginTop: 1}} value={confirmPassword} name="confirmPassword" type="password" fullWidth={true} error={confirmPasswordInvalid} required={true} label="Confirm Password" id="confirmPassword" autoComplete="false" onChange={validateConfirmPassword} />
        <FormControlLabel
          sx={{marginTop: 2}}
          control={
            <Checkbox
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              color="primary"
            />
          }
          label={
            <Typography>
              I accept the{' '}
              <Button 
                variant="text" 
                size="small" 
                onClick={() => setShowTerms(true)}
                sx={{textTransform: 'none', padding: 0, minWidth: 'auto'}}
              >
                Terms & Conditions
              </Button>
            </Typography>
          }
        />
        <Grid container justifyContent="center">
          <Box mt={3}>
            <Button variant="contained" color="primary" type="submit">Create</Button>
          </Box>
        </Grid>
      </form>
    </Container>
  );
}

export default CreateAccount;
